import Store from '../store'
export const loginCheck = (to, from, next) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (Store.getters.accessToken) {
        const verify = await Store.dispatch('verify', {})
        if (verify) return resolve(next('/overview'))
      }
    } catch (e) {
      Store.dispatch('logout').then(() => {
        return resolve(next())
      }).catch(e => {
        console.log(e)
        return resolve(next())
      })
    }
    return resolve(next())
  })
}



// WEBPACK FOOTER //
// ./src/router/loginCheck.js